import { AxiosResponse } from "axios";
import { makeAPIRequest } from "../hook/request";
import { API_ENDPOINT } from "../utils/constants";

class DiseaseAPI {}

export default new DiseaseAPI();
